var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hailingHistoryDetail"},[_c('PageHeader',{attrs:{"title":'行程詳細資訊'},on:{"toLastPage":_vm.toLastPage}}),_c('HistoryDetailTable',{staticClass:"hailingHistoryDetail__table",attrs:{"tripRecord":_vm.tripRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }